module.exports = __webpack_public_path__ + "static/media/logo.3c5612e2.jpg";